
























import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';

export type SalesReportSubmittedProduct = {
  productId: string;
  productName: string;
  soldAmount: number;
  refundedAmount: number;
};

type HeaderType = {
  text: string;
  value: string;
};

@Component({
  name: 'SalesReportConfirmDialogProducts',
})
export default class extends Vue {
  @Prop({ required: true }) products!: SalesReportSubmittedProduct[];
  private headers: HeaderType[] = [];

  mounted() {
    this.loadHeaders();
  }

  private loadHeaders() {
    const productName: HeaderType = {
      text: this.$t('Product name') as string,
      value: 'productName',
    };
    const soldAmount: HeaderType = {
      text: this.$t('Sold amount') as string,
      value: 'soldAmount',
    };
    const refundedAmount: HeaderType = {
      text: this.$t('Refunded amount') as string,
      value: 'refundedAmount',
    };
    const headers: HeaderType[] = [productName, soldAmount, refundedAmount];
    this.headers = headers;
  }
}
